import { render, staticRenderFns } from "./CouponCategory.vue?vue&type=template&id=188d6d88&"
import script from "./CouponCategory.vue?vue&type=script&lang=js&"
export * from "./CouponCategory.vue?vue&type=script&lang=js&"
import style0 from "./CouponCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports